module.exports = __webpack_public_path__ + "img/Kebab wrap Icon - charcoal.d9b95600.svg";